import twitterSVG from '../../assets/icons/twitter.svg';
import Edit from './Edit';
import View from './View';

export const juntsTwitterBlock = {
  id: 'junts_twitter',
  title: 'Twitter',
  icon: twitterSVG,
  group: 'common',
  view: View,
  edit: Edit,
  restricted: false,
  mostUsed: true,
  sidebarTab: 1,
  blockHasOwnFocusManagement: true,
};
